import React, { useState } from 'react';
import Button from '../common/Button';
import Typography from '../common/Typography';

const JoinCodeDisplay = ({ joinCode }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(joinCode);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy join code:', err);
    }
  };

  return (
    <div className="bg-info-light/30 border border-info rounded-lg p-4">
      <Typography variant="label" className="text-info-dark font-medium">
        Session Join Code
      </Typography>
      <div className="flex items-center gap-2 mt-2">
        <Typography variant="h4" className="font-mono text-text-primary">
          {joinCode}
        </Typography>
        <Button 
          onClick={handleCopy} 
          size="small"
          variant={copied ? 'primary' : 'secondary'}
        >
          {copied ? 'Copied!' : 'Copy'}
        </Button>
      </div>
      <Typography variant="caption" className="text-text-muted mt-1 block">
        Share this code with friends to join
      </Typography>
    </div>
  );
};

export default JoinCodeDisplay;
